import { render } from "./Denomination.vue?vue&type=template&id=76442c0a"
import script from "./Denomination.vue?vue&type=script&lang=js"
export * from "./Denomination.vue?vue&type=script&lang=js"

import exportComponent from "D:\\deploy\\fire-conference\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__